import * as React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemDetails,
} from '../accordion';
import {connectTracker, ITrackerProps} from '../../utils/tracker/index';
import {JobsPosition as Position} from './position';
import {IJobListItem, jobsList} from './data';
import {JobsHeader as Header} from './header';
import {JobsFormContainer} from './form-container';

import './styles.sass';

interface IJobsProps extends ITrackerProps {
  match: {
    params: {jobId: string};
  };
}

class Jobs extends React.Component<IJobsProps, {}> {

  public render(): React.ReactElement<any> {
    const {jobId} = this.props.match.params;

    return (
      <div className={'jobs-page'}>
        <Header />

        <Accordion>
          {jobsList.map((job: IJobListItem) => (
            <AccordionItem
              expanded={job.title === jobId}
              key={job.title}
            >
              <AccordionItemTitle
                link={this.getAccordionLink(job.title, jobId)}
                onClick={() => this.clickAccordionItem(job.title)}
              >
                <Position
                  expanded={job.title === jobId}
                  name={job.position}
                  city={job.city}
                />
              </AccordionItemTitle>

              <AccordionItemDetails
                expanded={job.title === jobId}
                text={job.description}
              >
                <JobsFormContainer
                  position={job.position}
                  jobKey={job.title}
                />
              </AccordionItemDetails>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    );
  }

  public componentDidMount(): void {
    const {match, trackOnce} = this.props;
    const {jobId} = match.params;
    trackOnce('jobs page', jobId ? {jobId} : {});
  }

  private getAccordionLink = (jobId: string, currentAccordionId: string): string => (
    `/jobs${jobId === currentAccordionId ? '' : `/${jobId}`}`
  );

  private clickAccordionItem = (jobId: string) => {
    const {track, match} = this.props;
    const expanded = jobId !== match.params.jobId;
    track('click job', {jobId, expanded});
  };

}

export const JobsContainer = connectTracker<IJobsProps>(Jobs);
